"use client"

import withWatchlist from "src/components/filmwebid/withWatchlist";
import StreamingTitleWithProviders from "src/components/streaming/streamingtitlewithproviders/StreamingTitleWithProviders";

const WLStreamingTitleWithProviders = withWatchlist(StreamingTitleWithProviders, "data");

export default WLStreamingTitleWithProviders;